export const LOCALSTORAGE_BASKET = 'basket';
export const LOCALSTORAGE_PICKUP = 'pickup';
export const LOCALSTORAGE_ADDRESS = 'address';
export const LOCALSTORAGE_ADDRESS_DETAILS = 'details';
export const LOCALSTORAGE_ADDRESS_BRANCH = 'branch';
export const LOCALSTORAGE_ORDER_STATUS = 'order-status';
export const LOCALSTORAGE_RECEIVE = 'receive';
